import { createContext } from 'react'

/**
 * What the "Allow to select" enable-and-allow dialog needs from the open draft when it turns
 * resources into workflow resources from inside it. The server then denies them on every
 * restricted field of the type, writing the open type in place.
 */
export interface IFormTypeEnabledResources {
  /** Copies that denial into the draft, which is saved as a whole type and would drop it. */
  denyEnabledResources: (
    resourceTypeId: string,
    recordIds: readonly string[],
  ) => void
}

/** Provided by FormTypeConfigurator; null outside one. */
export const FormTypeEnabledResourcesContext =
  createContext<IFormTypeEnabledResources | null>(null)
